import { render, staticRenderFns } from "./BoxMessage.vue?vue&type=template&id=68d3b355"
import script from "./BoxMessage.vue?vue&type=script&lang=js"
export * from "./BoxMessage.vue?vue&type=script&lang=js"
import style0 from "./BoxMessage.vue?vue&type=style&index=0&id=68d3b355&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports